export default __webpack_public_path__ + "static/media/FoxFics.439a0645.png";